module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-900.3c3f5501.woff2";